import request from '../utils/request';

export const localLogin = (params) => {
    return request({
        url: '/localLogin/authenticate',
        method: 'post',
        data: params
    });
}
export const login = (cookie) => {
    return request({
        url: `/login/authenticate/${cookie}`,
        method: 'post',
    });
}
export const logout = () => {
    return request({
        url: 'logoutUrl',
        method: 'get'
    });
}
